<template>
  <div>
    <div class="container-fluid">
      <div class="row pt-2 pb-2 pl-5 pr-5">
        <div class="col-auto mr-auto">
          <div class="navbar-header">
            <a href="https://lco.global" title="LCO.global" rel="home" class="navbar-brand">
              <img id='lco-logo' src="https://cdn.lco.global/mainstyle/img/LCO-logo-web.jpg"
                   alt="Las Cumbres Observatory"/>
            </a>
            <a id="lco-name" class="navbar-brand">
              {{ pageTitle }}
            </a>
          </div>
        </div>
        <div class="col-auto">
          <span>
          <time-panel :current-timestamp="currentTimestamp"
                      :start-timestamp="startTimestamp"
                      :end-timestamp="endTimestamp">
          </time-panel>
          </span>
        </div>
      </div>
    </div>
    <div class='container-fluid intro downPage blue'>
      <div class='row pt-2 pb-2 pl-5 pr-5'>
        <div class='col'>
          <span class='welcome-text welcome-text-big'>{{ leftText }} </span>
        </div>
        <div class="col right-aligned">
            <span v-for="link in links">
              <template v-if="link.target.startsWith('#')">
                <a data-toggle="modal" :data-target="link.target" href="" class="link-text pl-4">{{ link.text }}</a>
              </template>
              <template v-else>
                <router-link :to="link.target" class="link-text pl-4">{{ link.text }}</router-link>
              </template>
            </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TimePanel from 'timePanel.vue';

  export default {
    components: {TimePanel},
    name: 'page-heading',
    props: {
      pageTitle: {},
      leftText: {},
      linkUrl: {},
      linkText: {},
      currentTimestamp: {},
      startTimestamp: {},
      endTimestamp: {},
      links: {}
    }
  };
</script>